import type { Type } from '.';

export const IsPropsType = {
	Component: {
		Select: ComponentSelect,
		Input: {
			Text: ComponentTextInput,
			Money: ComponentMoneyInput,
			Number: ComponentNumberInput,
		},
	},
};

type Key = Type.Factory.Key; // alias

// C = component, alias
namespace C {
	export namespace Props {
		export type Any = Type.Factory.Component.Props<Key>;
		// G = generic, alias
		export type G<K extends Key> = Type.Factory.Component.Props<K>;
	}
}

function ComponentSelect(props: C.Props.Any): props is C.Props.G<'Select'> {
	return props._type === 'Select';
}

function ComponentTextInput(props: C.Props.Any): props is C.Props.G<'Text'> {
	return props._type === 'Text';
}

function ComponentMoneyInput(props: C.Props.Any): props is C.Props.G<'Money'> {
	return props._type === 'Money';
}

function ComponentNumberInput(props: C.Props.Any): props is C.Props.G<'Number'> {
	return props._type === 'Number';
}
